import { call, put, fork, takeLatest, select } from 'redux-saga/effects';
import { requestUserDetails } from '../requesters/userRequester';
import { receiveCurrentUserDetails } from '../actions/currentUserActions';
import { receiveUserDetails } from '../actions/userActions';
import { REQUEST_CURRENT_USER_DETAILS } from '../constants/actionTypes';

/**
 * Calls requestUserDetails to fetch the current user's details, then dispatches
 * receiveCurrentUserDetails with the results
 * @param {Object} action
 * @return {void}
 */
export function* getCurrentUserDetails(action) {
  const userDetails = yield call(requestUserDetails, action.id);
  yield put(receiveCurrentUserDetails(userDetails));

  const state = yield select();
  if (state.user.id === userDetails.id) {
    yield put(receiveUserDetails(userDetails, true));
  }

  return userDetails;
}

/**
 * Waits for the return of the REQUEST_CURRENT_USER_DETAILS action event and calls
 * the getCurrentUserDetails saga
 * @return {void}
 */
export function* getCurrentUserDetailsWatcher() {
  yield takeLatest(REQUEST_CURRENT_USER_DETAILS, getCurrentUserDetails);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(getCurrentUserDetailsWatcher);
}
